export function canonicalUrlFor(path?: string): string | null {
  if (typeof window === 'undefined') return null;
  const { origin, pathname } = window.location;
  const target = path ?? pathname;
  return `${origin}${target}`;
}

export function metaDescription(text: string): string {
  return text.length > 155 ? `${text.slice(0, 152)}...` : text;
}

